<template>
  <el-dialog
    title="修改历史记录"
    :visible.sync="visible"
    width="80%"
    :before-close="handleClose"
  >
    <el-table
      :data="historyData"
      style="width: 100%"
      :header-cell-style="headerStyle"
      :row-class-name="tableRowClassName"
      v-loading="loading"
    >
      <el-table-column prop="id" label="序号" align="center" width="80"></el-table-column>
      <el-table-column prop="operationType" label="操作类型" align="center" width="100"></el-table-column>
      <el-table-column prop="operator" label="操作人" align="center" width="100"></el-table-column>
      <el-table-column prop="operateTime" label="操作时间" align="center" width="180"></el-table-column>
      <el-table-column prop="changeInfo" label="变更信息" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.changeInfo || '-' }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageParams.pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageParams.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </el-dialog>
</template>

<script>
import { getEmployeeHistory } from '@/api/employee';
export default {
  name: 'HistoryDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    employeeId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      total: 0,
      pageParams: {
        pageNum: 1,
        pageSize: 10
      },
      historyData: [],
      headerStyle: {
        background: '#4e71be',
        color: '#fff',
        fontWeight: 'bold',
        textAlign: 'center'
      }
    };
  },
  methods: {
    tableRowClassName({ rowIndex }) {
      return rowIndex % 2 === 0 ? 'even-row' : 'odd-row';
    },
    handleClose() {
      this.$emit('update:visible', false);
    },
    handleSizeChange(val) {
      this.pageParams.pageSize = val;
      this.getHistoryList();
    },
    handleCurrentChange(val) {
      this.pageParams.pageNum = val;
      this.getHistoryList();
    },
    async getHistoryList() {
      this.loading = true;
      try {
        const res = await getEmployeeHistory(this.employeeId, this.pageParams);
        const logs = res.data.data.logs.map(log => {
          let changeInfo = '-';
          try {
            const content = JSON.parse(log.operation_content.replace(/'/g, '"'));
            changeInfo = Object.entries(content)
              .map(([key, value]) => `${key}: ${value}`)
              .join('\n');
          } catch (e) {
            changeInfo = log.operation_content;
          }
          return {
            id: log.id,
            operationType: log.operation_type,
            operator: log.operator,
            operateTime: new Date(log.created_at).toLocaleString(),
            changeInfo
          };
        });
        this.historyData = logs;
        this.total = res.data.data.total;
      } catch (error) {
        this.$message.error('获取历史记录失败：' + error.message);
      } finally {
        this.loading = false;
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.getHistoryList();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination-container {
  margin-top: 15px;
  display: flex;
  justify-content: flex-end;
}

::v-deep .el-table {
  .even-row {
    background-color: #ced4e8;
  }
  .odd-row {
    background-color: #e9ebf3;
  }
  td.el-table__cell {
    border: 0.5px solid #fff;
  }
}
</style>